import { render, staticRenderFns } from "./ManageStaffQualifications.vue?vue&type=template&id=49fd148a&scoped=true&"
import script from "./ManageStaffQualifications.vue?vue&type=script&lang=js&"
export * from "./ManageStaffQualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd148a",
  null
  
)

export default component.exports